var fp_testimonials = ( function( $ ) {

	var $wrapper,
		$logo_slider,
		$testimonial_slider;

	var _init = function() {
		$wrapper            = $( '#fp-testimonials' );
		$logo_slider        = $wrapper.find( '.testimonial-logo-slider .carousel' );
		$testimonial_slider = $wrapper.find( '.testimonial-slider .carousel' );

		_setup_carousels();
	};

	var _setup_carousels = function() {
		_setup_testimonial_slider();
		_setup_logo_slider();
	};

	var _setup_logo_slider = function() {
		$logo_slider.slick( {
			arrows: false,
			dots: true,
			centerMode: true,
			centerPadding: 0,
			slidesToShow: 3,
			initialSlide: $wrapper.data( 'start-slide' ),
			infinite : false,
			asNavFor: $testimonial_slider,
			focusOnSelect: true,
			responsive: [{
				breakpoint: 992,
					settings: {
						slidesToShow: 3
					}
			},{
			breakpoint: 480,
				settings: {
					slidesToShow: 1
				}
			}]
		} );
	};

	var _setup_testimonial_slider = function() {
		$testimonial_slider.slick( {
			arrows: true,
			dots: false,
			fade: true,
			slidesToShow: 1,
			initialSlide: $wrapper.data( 'start-slide' ),
			infinite : false,
			asNavFor: $logo_slider,
			adaptiveHeight: true,
			responsive: [{
				breakpoint: 480,
				settings: {
					arrows: false
				}
			}]
		} );
	};

	if ( $( '#fp-testimonials' ).length > 0 ) {
		_init();
	}

} ) ( jQuery );

module.exports = fp_testimonials;